/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_AnalyticsInputs */

const en_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics dashboard`)
};

const de_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysen-Dashboard`)
};

const fr_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord analytique`)
};

const es_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de análisis`)
};

const it_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard analitica`)
};

const nl_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytisch dashboard`)
};

const pl_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel analityczny`)
};

const fi_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikkapaneeli`)
};

const da_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysedashboard`)
};

const sv_pricing_compare_analytics = /** @type {(inputs: Pricing_Compare_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysinstrumentpanel`)
};

/**
* | output |
* | --- |
* | "Analytics dashboard" |
*
* @param {Pricing_Compare_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_analytics = /** @type {((inputs?: Pricing_Compare_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_analytics(inputs)
	if (locale === "fr") return fr_pricing_compare_analytics(inputs)
	if (locale === "es") return es_pricing_compare_analytics(inputs)
	if (locale === "it") return it_pricing_compare_analytics(inputs)
	if (locale === "nl") return nl_pricing_compare_analytics(inputs)
	if (locale === "pl") return pl_pricing_compare_analytics(inputs)
	if (locale === "fi") return fi_pricing_compare_analytics(inputs)
	if (locale === "da") return da_pricing_compare_analytics(inputs)
	if (locale === "sv") return sv_pricing_compare_analytics(inputs)
	return en_pricing_compare_analytics(inputs)
});